export default "__VITE_ASSET__67a7c60b__"